import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { BreadcrumbItem } from '../layout/modeles/breadcrumb-item';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private itemsSource = new BehaviorSubject<BreadcrumbItem[]>([]);

  itemsHandler = this.itemsSource.asObservable();

  setItems(items: BreadcrumbItem[]): void {
    this.itemsSource.next(items);
  }

  public getItems(): BehaviorSubject<BreadcrumbItem[]> {
    return this.itemsSource;
  }

  // add an item to the breadcrumb
  public appendItem(item: BreadcrumbItem): void {
    const currentItems = this.itemsSource.getValue();
    this.itemsSource.next([...currentItems, item]);
  }

  //replace the last item in the breadcrumb
  public setLastItem(item: BreadcrumbItem): void {
    const currentItems = this.itemsSource.getValue();
    
    if (currentItems.length > 0) {
      currentItems[currentItems.length - 1] = item; // Replace last item in breadcrumb trail
    } else {
      currentItems.push(item); // If empty, just set the item
    }
    
    this.itemsSource.next([...currentItems]); // Update breadcrumbs
  }
}
